/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_Hint_RequirementInputs */

const cs_ruian_hint_requirement = /** @type {(inputs: Ruian_Hint_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraj, obec, městská část, ulice nebo přesná adresa — kolem bodu nastavíte okruh.`)
};

const en_ruian_hint_requirement = /** @type {(inputs: Ruian_Hint_RequirementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region, municipality, district, street, or exact address — then set a radius around that point.`)
};

/**
* | output |
* | --- |
* | "Region, municipality, district, street, or exact address — then set a radius around that point." |
*
* @param {Ruian_Hint_RequirementInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_hint_requirement = /** @type {((inputs?: Ruian_Hint_RequirementInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_Hint_RequirementInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_hint_requirement(inputs)
	return cs_ruian_hint_requirement(inputs)
});